<template>
  <v-dialog
      v-model="dialog"
      persistent
      max-width="290"
  >
    <v-card>
      <v-card-text class="pa-0">
        <p class="pa-4 text-body-1 ma-0">{{configs.request_confirmation_message}}</p>
      </v-card-text>

      <div class="pa-4">
        <v-btn
            elevation="0"
            block
            @click="$emit('close')"
        >
          {{ configs.request_confirmation_negative_text }}
        </v-btn>

        <v-btn
            color="primary"
            block
            class="mt-3"
            elevation="0"
            @click="$emit('confirm')"
        >
          {{ configs.request_confirmation_positive_text }}
        </v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>

export default {
  name: "DialogShowMessage",
  props: ['dialog'],
  setup () {
    const configs = _config.functionalities.digitalmenu.configs
    return { configs }
  },
}
</script>

<style scoped>

</style>